<h1>Verticals</h1>
<span class="messages">
    <img src="/wp-content/themes/swarm/app/assets/images/loading.gif" *ngIf="loading" class="loader">
    <span class="save-text" *ngIf="saved"><mat-icon>check</mat-icon> Saved!</span>
    <span class="error-text" *ngIf="error"><mat-icon>error_outline</mat-icon> {{error}} </span>
    <span class="editor-text" *ngIf="canEdit && verticalsEditor"> {{verticalsEditor}} is currently editing <button type="button" class="button small" (click)="setLock('update')">Take Over</button></span>
</span>
<div class="verticals-table">
    <table mat-table [dataSource]="verticalsService.getVerticals()" class="mat-elevation-z8">
        <!-- Position Column -->
        <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns; index as i">
            <th mat-header-cell *matHeaderCellDef> {{column}} </th>
            <td mat-cell *matCellDef="let data"> 
                <sites-component 
                    *ngIf="column === 'Site'"
                    [(sites)]="data.site">
                </sites-component>
                <mat-checkbox
                    *ngIf="column !== 'Site'"
                    [name]="data.site[0].blog_id + '-' + data.states[i].term_id"
                    [checked]="data.states[i].allowed"
                    [disabled]="loading || !canEdit"
                    (change)="updateVertical($event, data.site[0].blog_id, data.states[i].term_id)">
                </mat-checkbox>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>